var keyMirror = require('keymirror');

module.exports = {
    endPoints: {
        LOAD_GUEST_AVATAR: 'api/v2/guest/avatar',
        LOAD_FULL_GUEST: 'api/v2/guest/details',
        CREATE_NEW_GUEST: 'api/v2/guest/create',
        EDIT_GUEST_PROFILE: 'api/v2/guest/edit-details',
        GET_DISCOUNT_GROUPS: 'api/v2/discount/Available_groups',
        GET_DOCTOR_LIST: 'api/v2/guest/Doctor_list',
        GET_CAREGIVER_LIST: 'api/v2/guest/caregiver_list',

        UPDATE_PRIMARY_ID: 'api/v2/guest/update_patient_primary_identification_image',
        DELETE_PRIMARY_ID: 'api/v2/guest/Remove_Patient_Primary_identification',

        REMOVE_SECONDARY_ID: 'api/v2/guest/remove-secondary-identification',
        EDIT_SECONDARY_ID: 'api/v2/guest/edit-secondary-identification',
        LOAD_SECONDARY_ID: 'api/v2/guest/secondary-identification',

        VIEW_PATIENT_NOTES: 'api/v2/guest/View_Patient_Notes',
        EXPORT_TRANSACTION_HISTORY: 'api/v2/product/Export_Transaction_History',
        EXPORT_PRODUCT_HISTORY: 'api/v2/product/Export_Product_History',

        NEW_TRANSACTION: 'api/v2/guest/New-Transaction',

        /* JOURNAL NOTES */
        UPDATE_JOURNAL_NOTE: 'api/v2/guest/Update_Patient_Notes',
        GET_TRANSACTION_NOTE: 'api/posv3/backendpos/GetTransactionNotes',
        SET_TRANSACTION_NOTE: 'api/posv3/backendpos/UpdateTransactionNotes',

        /* PATIENT NOTES */
        UPDATE_NOTE: 'api/v2/guest/UpdateNotes',

        ADJUST_LOYALTY_POINTS: 'api/posv3/maintenance/LoyaltyAdjustment',
        GET_QUALIFIED_CONDITIONS: 'api/posv3/maintenance/get-qualifying-conditions',

        ACCESS_STOREFRONT: 'api/v2/guest/GuestOnlineStatus',

        SET_STATUS: 'api/posv3/maintenance/UpdateTransactionStatus',

        SET_ATTESTATION: 'api/posv3/backendpos/UpdateAttestation',
        SET_ALLOTMENT: 'api/v2/guest/UpdateAllotment',

        SET_CURRENT_ALLOTMENT: 'api/v2/guest/UpdateCurrentAllotment',
        SET_MAX_ALLOTMENT: 'api/v2/guest/UpdateMaxAllotment',
        CLEAR_CURRENT_ALLOTMENT: 'api/v2/guest/ClearCurrentAllotment',
        CLEAR_MAX_ALLOTMENT: 'api/v2/guest/ClearMaxAllotment',

        EDIT_EXTERNAL_PATIENT_ALLOTMENT: 'api/v2/guest/EditExternalPatientAllotment',

        SET_DAYS_SUPPLY_REMAINING: 'api/v2/guest/UpdateDaysSupplyRemaining',

        GET_POLICY_AGREEMENT: 'api/v2/guest/get-policy-agreement',
        SET_POLICY_AGREEMENT: 'api/v2/guest/save-policy-agreement-signature',

        SAVE_CHECKOUT_SIGNATURE: 'api/v2/guest/save-checkout-signature',
        VERIFY_CUSTOMER_BIRTHDAY: 'api/v2/cart/verify-customer-birthdate',
        GET_GUEST_FILE_LIST: 'api/v2/guest/get-file-list',
        UPLOAD_GUEST_FILE: 'api/v2/guest/upload-file',
        DOWNLOAD_GUEST_FILE: 'api/v2/guest/download-file',
        DELETE_GUEST_ADDRESS: 'api/v2/guest/delete-address',

        CONVERT_GUEST_NON_ANON: 'api/v2/guest/ConvertToNonAnonymous',

        GET_PRESCRIPTIONS: 'api/v2/guest/get-prescriptions',
        ADD_PRESCRIPTION: 'api/v2/guest/add-prescription',
        COMPLETE_PRESCRIPTION: 'api/v2/guest/complete-prescription',
        DELETE_PRESCRIPTION: 'api/v2/guest/delete-prescription',
    },

    actions: keyMirror({
        GUEST_LOADED: null,
        GUEST_LOAD_FAIL: null,
    }),

    events: keyMirror({
        CHANGE_EVENT: 'changeEvent',
    }),
};

// /api/v2/guest/edit-details
// /api/v2/guest/checked-in

// /api/v2/guest/details
// /api/v2/guest/create



// WEBPACK FOOTER //
// ./ui_src/app/constants/GuestConstants.jsx